import { BN } from 'bn.js';
import { formatAddress } from '../helpers';

export function getAccountAddressFromId(walletAddress: string, accountId: number) {
  const hexWalletAddress = new BN(walletAddress.slice(2), 'hex');
  const accountAddress = hexWalletAddress.xor(new BN(accountId));

  return formatAddress(accountAddress.toString('hex'));
}
